var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0247 2.39038C14.6272 2.39038 18.3581 6.12121 18.3581 10.7237C18.3581 15.3262 14.6272 19.057 10.0247 19.057C5.42224 19.057 1.69141 15.3262 1.69141 10.7237C1.69141 6.12121 5.42224 2.39038 10.0247 2.39038ZM13.6222 8.06371C13.5315 7.97301 13.4105 7.91898 13.2824 7.91199C13.1543 7.90499 13.0281 7.94552 12.9281 8.0258L12.8856 8.06371L8.67057 12.2787L7.16391 10.772C7.06972 10.6778 6.94302 10.6233 6.80985 10.6196C6.67668 10.616 6.54717 10.6635 6.44796 10.7524C6.34875 10.8413 6.28738 10.9649 6.27647 11.0976C6.26557 11.2304 6.30595 11.3623 6.38932 11.4662L6.42724 11.5087L8.30224 13.3837C8.39296 13.4744 8.51397 13.5284 8.64207 13.5354C8.77017 13.5424 8.89634 13.5019 8.99641 13.4216L9.03891 13.3837L13.6222 8.80038C13.6706 8.75202 13.709 8.69459 13.7352 8.63139C13.7614 8.56819 13.7748 8.50046 13.7748 8.43205C13.7748 8.36364 13.7614 8.2959 13.7352 8.2327C13.709 8.1695 13.6706 8.11208 13.6222 8.06371Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedIcon);
export default __webpack_public_path__ + "static/media/checked_icon.bbf922346ad1798585e1cc5fc5c6f048.svg";
export { ForwardRef as ReactComponent };